import type { IAdaptFaq } from '@/types/shared-types'

export const useFetchFaq = async () => {
  const route = useRoute()
  const { locale } = useI18n()

  const fetchFaq = async (faqId: string) => {
    return await useAsyncData(
      `faq-${route.path}-${locale}-${faqId}`,
      async () => {
        const response = await $fetch<{ faq: IAdaptFaq | null }>(
          '/api/v1/contentful/investor/faq',
          {
            query: {
              locale: locale.value,
              path: route.path,
              faqId,
            },
          },
        )
        return response?.faq ?? null
      })
  }
  return { fetchFaq }
}
